import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { isAcknowledgedUnresolvedNotification } from '../utils/adminNotificationMeta';

export default function AdminTopBar({ title = 'Genel Bakış', onToggleMobile }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  const fetchUnread = async () => {
    try {
      const adminToken = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
      const res = await fetch(`${API_BASE_URL}/api/notifications`, {
        headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {}
      });
      if (res.ok) {
        const data = await res.json();
        const notifications = Array.isArray(data.notifications) ? data.notifications : [];
        const unreadNotifications = notifications.filter((n) => !n.isRead);
        const acknowledgedUnresolved = notifications.filter(isAcknowledgedUnresolvedNotification);
        const unresolvedAware = unreadNotifications.length + acknowledgedUnresolved.filter((ack) => !unreadNotifications.some((u) => u.id === ack.id)).length;
        const unread = unresolvedAware || 0;
        setUnreadCount(unread);
      }
    } catch (err) {
      console.warn('AdminTopBar notification fetch failed', err);
    }
  };

  useEffect(() => {
    fetchUnread();
    window.addEventListener('refreshNotifications', fetchUnread);
    window.addEventListener('realtime:notifications-updated', fetchUnread);
    window.addEventListener('realtime:force-refetch', fetchUnread);
    const interval = setInterval(fetchUnread, 300000);
    return () => {
      window.removeEventListener('refreshNotifications', fetchUnread);
      window.removeEventListener('realtime:notifications-updated', fetchUnread);
      window.removeEventListener('realtime:force-refetch', fetchUnread);
      clearInterval(interval);
    };
  }, []);

  return (
    <header className="w-full h-16 bg-white dark:bg-[#101922] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-4 md:px-8 shrink-0">
      <div className="flex items-center gap-3">
        {/* Mobile hamburger - visible on small screens only */}
        <button onClick={onToggleMobile} className="md:hidden p-2 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800">
          <span className="material-symbols-outlined">menu</span>
        </button>
        <div className="flex flex-col justify-center">
          <h2 className="text-xl font-bold text-slate-800 dark:text-white">{title}</h2>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="hidden md:block">
          <div className="relative">
            <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xl">search</span>
            <input
              className="pl-10 pr-4 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm focus:outline-none focus:ring-2 focus:ring-primary w-64"
              placeholder="Ara..."
              type="text"
            />
          </div>
        </div>
        <button
          onClick={() => navigate('/admin/notifications')}
          className="relative size-9 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-300 hover:bg-primary/10 hover:text-primary transition-colors"
        >
          <span className="material-symbols-outlined">notifications</span>
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-600 text-[10px] font-black text-white ring-2 ring-white dark:ring-[#101922]">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}

